import React from "react"
import "./project_entry.scss"

import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Card from "react-bootstrap/Card"
import Image from "react-bootstrap/Image"
import Button from "react-bootstrap/Button"

export default function ProjectEntry(props) {
  return (
    <Card className="project-entry">
      <Container>
        <Row>
          <Col md={12} lg={6}>
            <div className="details">
              <div className="header">
                <div className="title">{props.title}</div>
                <div className="date">{props.date}</div>
              </div>
              <div className="description">{props.description}</div>
              {props.tags && (
                <div className="tags">
                  {props.tags.map(tag => {
                    return <div className="pill">{tag}</div>
                  })}
                </div>
              )}
              <div className="text-right">
                {props.link && (
                  <Button variant="primary" href={props.link} target="_blank">
                    MORE &gt;
                  </Button>
                )}
                {props.code && (
                  <Button variant="secondary" href={props.code} target="_blank">
                    CODE &gt;
                  </Button>
                )}
              </div>
            </div>
          </Col>
          <Col md={6} style={{ margin: "auto" }}>
            <Image src={props.image} fluid />
          </Col>
        </Row>
      </Container>
    </Card>
  )
}
